module.exports = __webpack_public_path__ + "static/media/7c.56a33597.svg";